import { tryParseJSONstr } from "./utils/extend";

window.basicInfoCallback = null;

window.setBasicInfo = function (data: string) {
  try {
    const obj = tryParseJSONstr(data);
    window.basicInfoCallback?.resolve?.(obj);
  } catch (err) {
    window.basicInfoCallback?.resolve?.({});
  } finally {
    window.basicInfoCallback = null;
  }
};

export {};
